import isPropValid from "@emotion/is-prop-valid";
import styled from "styled-components";
import { px } from "../../../mixins/formatters";
import { trackContainerSize } from "../config";
export const Wrapper = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  right: 0;
  bottom: 0;

  &.preserveTrackSpace {
    margin-right: ${px(trackContainerSize * 2)} !important;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV3JhcHBlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1Njcm9sbGJhci9zdHlsZWQvV3JhcHBlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFdBQVcsTUFBTSx3QkFBd0IsQ0FBQztBQUNqRCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEVBQUUsRUFBRSxFQUFFLE1BQU0sNEJBQTRCLENBQUM7QUFDaEQsT0FBTyxFQUFFLGtCQUFrQixFQUFFLE1BQU0sV0FBVyxDQUFDO0FBRS9DLE1BQU0sQ0FBQyxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQztJQUMzQyxpQkFBaUIsRUFBRSxXQUFXO0NBQy9CLENBQUMsQ0FBQTs7Ozs7b0JBS2tCLEVBQUUsQ0FBQyxrQkFBa0IsR0FBRyxDQUFDLENBQUM7O0NBRTdDLENBQUMifQ==